import { Button, Flex } from '@chakra-ui/react';
import { FC, useEffect } from 'react';
import useLogger from '../hooks/useLogger';

type Props = {
  error: Error;
  resetErrorBoundary: () => void;
};
const ErrorFallback: FC<Props> = ({ error, resetErrorBoundary }) => {
  const logger = useLogger();
  useEffect(() => {
    logger.error('ErrorBoundary:', error);
  }, [error]);
  return (
    <Flex role="alert" justifyContent={'center'} alignItems={'center'} flexDirection={'column'} height={'100svh'}>
      <p>An error has occurred.:</p>
      <pre style={{ color: 'red' }}>{error.message}</pre>
      <Button onClick={resetErrorBoundary} colorPalette={'gray'} color={'white'}>
        Reload
      </Button>
    </Flex>
  );
};
export default ErrorFallback;
